export default class StatisticsPerRepresentative {
  valor!: number;

  total!: number;

  codRepresentante!: string;

  representante!: string;
}
